<script setup lang="ts">
import PaidPlanBadge from '@/components/dashboard/ui/PaidPlanBadge.vue'
import paywallPreviewImgDesktop from '@/assets/images/swiftaid-donor-dashboard-desktop.jpg'
import paywallPreviewImgMobile from '@/assets/images/swiftaid-donor-dashboard-mobile.jpg'

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <div class="sa-giving-paywall">
    <div class="sa-giving-paywall__content">
      <div class="sa-giving-paywall__icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <h2 class="sa-giving-paywall__title">{{ $t('Dashboard.Giving.Paywall.Title') }}</h2>
      <p class="sa-giving-paywall__text">{{ $t('Dashboard.Giving.Paywall.Text') }}</p>
      <button type="button" class="sa-btn-purple" @click="emit('upgrade')">
        {{ $t('Dashboard.Home.UpgradeCta') }}
        <PaidPlanBadge />
      </button>
    </div>
    <div class="sa-giving-paywall__media" aria-hidden="true">
      <picture>
        <source
          media="(max-width: 767.98px)"
          :srcset="paywallPreviewImgMobile"
        />
        <img
          :src="paywallPreviewImgDesktop"
          alt=""
          decoding="async"
          width="1233"
          height="1024"
        />
      </picture>
    </div>
  </div>
</template>
